// Menu Icons
import { ReactComponent as HomeIcon } from "../static/home.svg";
import { ReactComponent as ProjectsIcon } from "../static/projects.svg";
import { ReactComponent as CompaniesIcon } from "../static/companies.svg";
import { ReactComponent as FormTemplatesIcon } from "../static/form-templates.svg";
import { ReactComponent as FormboxIcon } from "../static/formbox.svg";
import { ReactComponent as FormsIcon } from "../static/forms.svg";
import { ReactComponent as ReportsIcon } from "../static/reports.svg";
import { ReactComponent as SettingsIcon } from "../static/settings.svg";
import { ReactComponent as TasksIcon } from "../static/tasks.svg";
import { MdAccountCircle } from "react-icons/md";
import { IoMdGitMerge } from "react-icons/io";

/* eslint-disable no-unused-vars */
import Account from "../pages/Account/Account";
import Companies from "../pages/Companies/Companies";
import Company from "../pages/Companies/Company";
import CompanyInfo from "../pages/Companies/CompanyPages/CompanyInfo";
import CompanyUsers from "../pages/Companies/CompanyPages/CompanyUsers";
import Dashboard from "../pages/Dashboard/Dashboard";
import Formbox from "../pages/Formbox/Formbox";
import FormboxDetail from "../pages/Formbox/FormboxDetail";
import Login from "../pages/Login/Login";
import Projects from "../pages/Project/Projects";
import Register from "../pages/Register/Register";
import ResetPassword from "../pages/ResetPassword/ResetPassword";
import Forms from "../pages/Forms/Forms";
import NewForm from "../pages/Forms/NewForm";
import FormsDetail from "../pages/Forms/FormsDetail";
import FormTemplates from "../pages/FormTemplates/FormTemplates";
import ProjectSettings from "../pages/ProjectSettings/ProjectSettings";
import Tasks from "../pages/Tasks/Tasks";
import TaskDetail from "../pages/Tasks/TaskDetail";

import PersonalInformation from "../pages/Account/components/PersonalInformation";
import AccountSettings from "../pages/Account/components/AccountSettings";
import CompanyGroups from "../pages/Companies/CompanyPages/CompanyGroups";
import ForgotPassword from "../pages/ForgotPassword/ForgotPassword";
import LocationSets from "../pages/ProjectSettings/components/LocationSets";
import StatusSets from "../pages/ProjectSettings/components/StatusSets";
import RevisionSets from "../pages/ProjectSettings/components/RevisionSets";
import CompaniesAndRoles from "../pages/ProjectSettings/components/CompaniesAndRoles";
import MetadataSets from "../pages/ProjectSettings/components/MetadataSets";
import FormContentLayout from "../pages/Forms/components/FormContentLayout";
import EventListTable from "../pages/Forms/components/EventListTable";
import FormTemplatesDetails from "../pages/FormTemplates/FormTemplatesDetails";
import TemplateGeneralInfo from "../pages/FormTemplates/components/TemplateGeneralInfo";
import Metadata from "../pages/FormTemplates/components/Metadata";
import Authorization from "../pages/FormTemplates/components/Authorization";
import TemplateStructure from "../pages/FormTemplates/components/TemplateStructure";
import Reports from "../pages/Reports/Reports";
import DesignApprovalProcess from "../pages/DesignApprovalProcess/DesignApprovalProcess";
import DesignApprovalProcessDetail from "../pages/DesignApprovalProcess/DesignApprovalProcessDetail";
import GeneralSettings from "../pages/ProjectSettings/components/GeneralSettings";
import ProjectReports from "../pages/ProjectSettings/components/ProjectReports";
import CascadingLists from "../pages/FormTemplates/components/CascadingLists";
import FormDependencies from "../pages/ProjectSettings/components/FormDependencies";

export const global = {};

export const auth = {
  dashboard: {
    id: "auth-dashboard",
    name: "dashboard",
    property: Dashboard,
    link: "/",
    exact: true,
    onMenu: true,
    icon: <HomeIcon />,
    order: 1,
    canView: ["admin", "project_admin", "manager", "form_admin", "form_user", "viewer"],
  },
  tasks: {
    id: "auth-tasks",
    name: "tasks",
    property: Tasks,
    link: "/tasks",
    exact: true,
    onMenu: true,
    icon: <TasksIcon />,
    order: 2,
    canView: ["admin", "project_admin", "manager", "form_admin", "form_user", "viewer"],
  },
  taskDetails: {
    id: "auth-task-details",
    name: "task-details",
    property: TaskDetail,
    link: "/tasks/:id",
    exact: true,
    onMenu: false,
    pages: [
      {
        id: "auth-form-content-layout",
        name: "form-details-form-content-layout",
        property: FormContentLayout,
        isIndex: true,
      },
      {
        id: "auth-event-list-table",
        name: "form-details-event-list-table",
        property: EventListTable,
        link: "event-list-table",
        exact: false,
        onMenu: false,
      },
    ],
    canView: ["admin", "project_admin", "manager", "form_admin", "form_user", "viewer"],
  },
  forms: {
    id: "auth-forms",
    name: "forms",
    property: Forms,
    link: "/forms",
    exact: true,
    onMenu: true,
    icon: <FormsIcon />,
    order: 3,
    canView: ["admin", "project_admin", "manager", "form_admin", "form_user", "viewer"],
  },
  newForm: {
    id: "auth-new-form",
    name: "new-form",
    property: NewForm,
    link: "/forms/new/:template",
    exact: true,
    onMenu: false,
    // order: 4,
    canView: ["admin", "project_admin", "manager", "form_admin", "form_user"],
  },
  formDetails: {
    id: "auth-form-details",
    name: "form-details",
    property: FormsDetail,
    link: "/forms/:id",
    exact: true,
    onMenu: false,
    pages: [
      {
        id: "auth-form-content-layout",
        name: "form-details-form-content-layout",
        property: FormContentLayout,
        isIndex: true,
      },
      {
        id: "auth-event-list-table",
        name: "form-details-event-list-table",
        property: EventListTable,
        link: "event-list-table",
        exact: false,
        onMenu: false,
      },
    ],
    canView: ["admin", "project_admin", "manager", "form_admin", "form_user", "viewer"],
  },
  formTemplates: {
    id: "auth-form-templates",
    name: "form-templates",
    property: FormTemplates,
    link: "/form-templates",
    exact: true,
    onMenu: true,
    icon: <FormTemplatesIcon />,
    order: 4,
    canView: ["admin", "project_admin", "manager", "form_admin"],
  },
  newFormTemplate: {
    id: "auth-new-form-template",
    name: "new-form-template",
    property: FormTemplatesDetails,
    link: "/form-templates/new",
    exact: true,
    pages: [
      {
        id: "auth-form-template-details-general-information",
        name: "template-details-general-information",
        property: TemplateGeneralInfo,
        isIndex: true,
      },
      {
        id: "auth-form-template-details-template-structure",
        name: "template-details-template-structure",
        property: TemplateStructure,
        link: "template-structure",
      },
      {
        id: "auth-form-template-details-template-header",
        name: "template-details-header",
        property: Metadata,
        link: "header",
      },
      {
        id: "auth-form-template-details-template-authorization",
        name: "template-details-authorization",
        property: Authorization,
        link: "authorization",
      },
    ],
    canView: ["admin", "project_admin", "manager", "form_admin"],
  },
  formTemplateDetails: {
    id: "auth-form-template-details",
    name: "form-template-details",
    property: FormTemplatesDetails,
    link: "/form-templates/:id",
    exact: true,
    onMenu: false,
    pages: [
      {
        id: "auth-form-template-details-general-information",
        name: "template-details-general-information",
        property: TemplateGeneralInfo,
        isIndex: true,
      },
      {
        id: "auth-form-template-details-template-structure",
        name: "template-details-template-structure",
        property: TemplateStructure,
        link: "template-structure",
      },
      {
        id: "auth-form-template-details-template-header",
        name: "template-details-header",
        property: Metadata,
        link: "header",
      },
      {
        id: "auth-form-template-details-template-authorization",
        name: "template-details-authorization",
        property: Authorization,
        link: "authorization",
      },
      {
        id: "auth-form-template-details-cascading-lists",
        name: "template-details-cascading-lists",
        property: CascadingLists,
        link: "cascading-lists",
      },
    ],
    canView: ["admin", "project_admin", "manager", "form_admin"],
  },
  designApprovalProcess: {
    id: "auth-workflows",
    name: "workflows",
    property: DesignApprovalProcess,
    link: "/workflows",
    exact: true,
    onMenu: true,
    icon: <IoMdGitMerge />,
    order: 5,
    canView: ["admin", "project_admin", "manager", "form_admin", "form_user", "viewer"],
  },
  designApprovalProcessDetail: {
    id: "auth-workflow-detail",
    name: "workflow-detail",
    property: DesignApprovalProcessDetail,
    link: "/workflows/:id",
    exact: true,
    onMenu: false,
    isIndex: true,
    canView: ["admin", "project_admin", "manager", "form_admin", "form_user", "viewer"],
  },
  formBox: {
    id: "auth-form-box",
    name: "form-box",
    property: Formbox,
    link: "/form-box",
    exact: true,
    onMenu: true,
    icon: <FormboxIcon />,
    order: 6,
    canView: ["admin", "project_admin", "manager", "form_admin", "form_user", "viewer"],
  },
  formBoxDetails: {
    id: "auth-form-box-details",
    name: "form-box-details",
    property: FormboxDetail,
    link: "/form-box/:id",
    exact: true,
    onMenu: false,
    canView: ["admin", "project_admin", "manager", "form_admin", "form_user", "viewer"],
  },
  companies: {
    id: "auth-companies",
    name: "companies",
    property: Companies,
    link: "/companies",
    exact: true,
    onMenu: true,
    icon: <CompaniesIcon />,
    order: 7,
    canView: ["admin", "project_admin", "manager"],
  },
  projectSettings: {
    id: "auth-project-settings",
    name: "project-settings",
    property: ProjectSettings,
    link: "/settings",
    exact: true,
    onMenu: true,
    icon: <SettingsIcon />,
    order: 8,
    canView: ["admin", "project_admin"],
    pages: [
      {
        id: "auth-project-settings-location-sets",
        name: "project-settings-location-sets",
        property: LocationSets,
        isIndex: true,
        translateKey: "location_sets",
      },
      {
        id: "auth-project-settings-status-sets",
        name: "project-settings-status-sets",
        property: StatusSets,
        link: "status-sets",
        exact: false,
        onMenu: false,
        translateKey: "status_sets",
      },
      {
        id: "auth-project-settings-revision-sets",
        name: "project-settings-revision-sets",
        property: RevisionSets,
        link: "revision-sets",
        exact: false,
        onMenu: false,
        translateKey: "revision_sets",
      },
      {
        id: "auth-project-settings-companies-and-roles",
        name: "project-settings-companies-and-roles",
        property: CompaniesAndRoles,
        link: "companies-and-roles",
        exact: false,
        onMenu: false,
        translateKey: "companies_and_roles",
      },
      {
        id: "auth-project-settings-metadata-sets",
        name: "project-settings-metadata-sets",
        property: MetadataSets,
        link: "metadata-sets",
        exact: false,
        onMenu: false,
        translateKey: "metadata_sets",
      },
      {
        id: "auth-project-settings-general-settings",
        name: "project-settings-general-settings",
        property: GeneralSettings,
        link: "general-settings",
        exact: false,
        onMenu: false,
        translateKey: "general_settings",
      },
      {
        id: "auth-project-settings-reports",
        name: "project-settings-reports",
        property: ProjectReports,
        link: "reports",
        exact: false,
        onMenu: false,
        translateKey: "reports",
      },
      {
        id: "auth-project-settings-form-dependencies",
        name: "project-settings-form-dependencies",
        property: FormDependencies,
        link: "form-dependencies",
        exact: false,
        onMenu: false,
        translateKey: "form_dependencies",
      },
    ],
  },
  company: {
    id: "auth-company",
    name: "company",
    property: Company,
    link: "/companies/:id",
    exact: true,
    onMenu: false,
    canView: ["admin", "project_admin", "manager"],
    pages: [
      {
        id: "auth-companies-company-info",
        name: "company-info",
        property: CompanyInfo,
        isIndex: true,
        icon: (
          <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 24 24"
            color="#fff"
            style={{ color: "rgb(255, 255, 255)" }}
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z"></path>
          </svg>
        ),
      },
      {
        id: "auth-companies-company-users",
        name: "company-users",
        property: CompanyUsers,
        link: "users",
        exact: false,
        onMenu: false,
        icon: (
          <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 448 512"
            color="#fff"
            style={{ color: "rgb(255, 255, 255)" }}
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"></path>
          </svg>
        ),
      },
      {
        id: "auth-companies-company-groups",
        name: "company-groups",
        property: CompanyGroups,
        link: "groups",
        exact: false,
        onMenu: false,
        icon: (
          <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 24 24"
            color="#fff"
            style={{ color: "rgb(255, 255, 255)" }}
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z"></path>
          </svg>
        ),
      },
    ],
  },
  projects: {
    id: "auth-projects",
    name: "projects",
    property: Projects,
    link: "/projects",
    exact: true,
    onMenu: true,
    icon: <ProjectsIcon />,
    order: 9,
    canView: ["admin", "project_admin"],
  },
  reports: {
    id: "auth-reports",
    name: "reports",
    property: Reports,
    link: "/reports",
    exact: true,
    onMenu: true,
    icon: <ReportsIcon />,
    order: 10,
    canView: ["admin", "project_admin", "manager", "form_admin", "form_user", "viewer"],
  },

  account: {
    id: "auth-account",
    name: "account",
    property: Account,
    link: "/account",
    exact: true,
    onMenu: false,
    canView: ["admin", "project_admin", "manager", "form_admin", "form_user", "viewer"],
    pages: [
      {
        id: "auth-account-info",
        name: "account-info",
        property: PersonalInformation,
        isIndex: true,
        exact: true,
        icon: <MdAccountCircle className="account-icon text-orange" />,
      },
      {
        id: "auth-account-settings",
        name: "account-settings",
        property: AccountSettings,
        link: "settings",
        exact: true,
        onMenu: false,
        icon: <MdAccountCircle className="account-icon text-orange" />,
      },
    ],
  },
};

export const guest = {
  login: {
    id: "guest-login",
    name: "login",
    property: Login,
    link: "/login",
    exact: true,
    onMenu: false,
  },
  register: {
    id: "guest-register",
    name: "register",
    property: Register,
    link: "/register",
    exact: true,
    onMenu: false,
  },
  forgotPassword: {
    id: "guest-forgot-password",
    name: "forgot-password",
    property: ForgotPassword,
    link: "/forgot-password",
    exact: true,
    onMenu: false,
  },
  resetPassword: {
    id: "guest-reset-password",
    name: "reset-password",
    property: ResetPassword,
    link: "/reset-password",
    exact: true,
    onMenu: false,
  },
};
